import type {
    IWebhookSubscriptionTableBaseModel,
    IWebhookSubscriptionTableModel,
} from "app/pages/sales-intelligence/modules/signals-api-webhook/types/row-data";

export const subscriptionsWithIndex = (
    subscriptions: readonly IWebhookSubscriptionTableBaseModel[],
): IWebhookSubscriptionTableModel[] => {
    return subscriptions.map((subscription, index) => ({
        ...subscription,
        index,
    }));
};
